import { useIntl } from 'react-intl';

const TotalPrice = ({
  products = [],
  services = [],
  giftcards = [],
  memberships = [],
  packages = [],
  tax,
  discount,
  loyaltyDiscount,
}: any) => {
  const intl = useIntl();
  let fixedDiscount = 0;
  console.log(giftcards);

  let totalPrice: number =
    services?.reduce(
      (acc: any, service: any) =>
        acc + Number(service?.price || service?.price),
      0
    ) +
    products?.reduce(
      (acc: any, product: any) =>
        acc +
        Number(product?.price || product?.retail_price) *
          Number(product?.qty || product?.quantity),
      0
    ) +
    packages?.reduce(
      (acc: any, pkg: any) => acc + Number(pkg?.retail_price),
      0
    ) +
    giftcards?.reduce(
      (acc: any, product: any) =>
        acc + Number(+product?.value || +product?.value),
      0
    ) +
    memberships?.reduce(
      (acc: any, product: any) =>
        acc + Number(product?.price || product?.price),
      0
    );

  if (loyaltyDiscount) {
    fixedDiscount +=
      (totalPrice *
        +loyaltyDiscount?.loyalty_program_range?.discount_percentage) /
      100;
  }
  if (discount) {
    if (discount?.type === 'fixed') {
      fixedDiscount += +discount?.value;
    }
    if (discount?.type === 'percentage') {
      fixedDiscount += (totalPrice * +discount?.value) / 100;
    }
  }

  let totalPriceWithDiscount = totalPrice - fixedDiscount;
  let taxValue = Number(
    (+totalPriceWithDiscount * +tax?.tax_rate) / 100
  ).toFixed(2);
  return (
    <div className=" bg-[#EEF0FF] py-2 rounded my-4 w-full">
      <div className="flex justify-between gap-2 p-2 font-semibold rounded">
        <p className="flex items-center gap-2">
          <span>
            {intl.formatMessage({
              id: tax ? 'subTotal' : 'totalPrice',
            })}
          </span>
        </p>

        <p className="flex items-center gap-1 ">
          <span className="text-lg text-color-primary">
            {Number(totalPrice).toFixed(2)}
          </span>
          <small className="self-center mt-2 text-xs">
            {intl.formatMessage({
              id: 'SAR',
              defaultMessage: 'ريال سعودي',
            })}
          </small>
        </p>
      </div>
      {fixedDiscount ? (
        <div className="flex justify-between gap-2 p-2 font-semibold rounded">
          <p className="flex items-center gap-2">
            <span>
              {intl.formatMessage({
                id: 'discount',
              })}
            </span>
          </p>

          <p className="flex items-center gap-1 ">
            <span className="text-lg text-color-primary">
              {Number(fixedDiscount).toFixed(2)}
            </span>
            <small className="self-center mt-2 text-xs">
              {intl.formatMessage({
                id: 'SAR',
                defaultMessage: 'ريال سعودي',
              })}
            </small>
          </p>
        </div>
      ) : null}

      {tax ? (
        <>
          <div className="flex justify-between gap-2 p-2 font-semibold rounded">
            <p className="flex items-center gap-2">
              <span>
                {intl.formatMessage({
                  id: 'tax',
                })}
              </span>
            </p>

            <p className="flex items-center gap-1 ">
              <span className="text-lg text-color-primary">
                {taxValue || 0}
              </span>
              <small className="self-center mt-2 text-xs">
                {intl.formatMessage({
                  id: 'SAR',
                  defaultMessage: 'ريال سعودي',
                })}
              </small>
            </p>
          </div>
          <div className="w-11/12 mx-auto bg-slate-300 px-10 h-[1px]" />
          <div className="flex justify-between gap-2 p-2 font-semibold rounded">
            <p className="flex items-center gap-2">
              <span>
                {intl.formatMessage({
                  id: 'totalPrice',
                })}
              </span>
            </p>

            <p className="flex items-center gap-1 ">
              <span className="text-lg text-color-primary">
                {Number((totalPriceWithDiscount += +taxValue)).toFixed(2)}
              </span>
              <small className="self-center mt-2 text-xs">
                {intl.formatMessage({
                  id: 'SAR',
                  defaultMessage: 'ريال سعودي',
                })}
              </small>
            </p>
          </div>
        </>
      ) : null}
    </div>
  );
};

export default TotalPrice;
